import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useHttpClient } from "shared/hooks/http-hook";

const BASE = () => `${process.env.REACT_APP_BACKEND_URL}/ride-skips`;

export const useRideSkipApi = () => {
  const { sendRequest, isLoading, error } = useHttpClient();
  const { t } = useTranslation();

  const surfaceError = useCallback(
    (err) => {
      if (err?.message) {
        window.toast?.error(err.message);
      } else if (err?.code) {
        window.toast?.error(t("httpCodes." + err.code));
      } else {
        window.toast?.error(t("actionFailed"));
      }
    },
    [t],
  );

  const listForService = useCallback(
    async ({ serviceKind, serviceId, day }) => {
      try {
        const params = new URLSearchParams({ serviceKind, serviceId });
        if (day) params.set("day", day);
        return await sendRequest(`${BASE()}?${params.toString()}`, "GET");
      } catch (err) {
        surfaceError(err);
        return { day, skips: [] };
      }
    },
    [sendRequest, surfaceError],
  );

  const upsert = useCallback(
    async (body) => {
      try {
        return await sendRequest(`${BASE()}`, "PUT", JSON.stringify(body));
      } catch (err) {
        surfaceError(err);
        throw err;
      }
    },
    [sendRequest, surfaceError],
  );

  const getSummary = useCallback(
    async (day) => {
      try {
        const params = day ? `?day=${encodeURIComponent(day)}` : "";
        return await sendRequest(`${BASE()}/summary${params}`, "GET");
      } catch (err) {
        return { day, summary: [] };
      }
    },
    [sendRequest],
  );

  return { listForService, upsert, getSummary, isLoading, error };
};
